import { Delete } from "@mui/icons-material";
import { IconButton, Stack, Tooltip, Typography } from "@mui/material";

interface CardHeaderProps {
  title: string | null | undefined;
  handleDelete?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const CardHeader = ({ title, handleDelete }: CardHeaderProps) => {
  const handleRemoveSkill = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();

    if (handleDelete) handleDelete(e);
  };

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      spacing={1}>
      {title ? (
        <Tooltip title={title}>
          <Typography
            variant='h20'
            sx={{
              display: "block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}>
            {title}
          </Typography>
        </Tooltip>
      ) : null}
      {handleDelete && (
        <IconButton
          onClick={handleRemoveSkill}
          // disabled={!isEditable}
        >
          <Delete />
        </IconButton>
      )}
    </Stack>
  );
};

export default CardHeader;
